var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Envelope",
    clipPath: "url(#clip0_36_1070)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 3.75H2.5C2.16848 3.75 1.85054 3.8817 1.61612 4.11612C1.3817 4.35054 1.25 4.66848 1.25 5V15C1.25 15.3315 1.3817 15.6495 1.61612 15.8839C1.85054 16.1183 2.16848 16.25 2.5 16.25H17.5C17.8315 16.25 18.1495 16.1183 18.3839 15.8839C18.6183 15.6495 18.75 15.3315 18.75 15V5C18.75 4.66848 18.6183 4.35054 18.3839 4.11612C18.1495 3.8817 17.8315 3.75 17.5 3.75ZM2.5 2.5C1.83696 2.5 1.20107 2.76339 0.732233 3.23223C0.263392 3.70107 0 4.33696 0 5L0 15C0 15.663 0.263392 16.2989 0.732233 16.7678C1.20107 17.2366 1.83696 17.5 2.5 17.5H17.5C18.163 17.5 18.7989 17.2366 19.2678 16.7678C19.7366 16.2989 20 15.663 20 15V5C20 4.33696 19.7366 3.70107 19.2678 3.23223C18.7989 2.76339 18.163 2.5 17.5 2.5H2.5Z",
    fill: "#512DA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0886602 5.30375C0.130837 5.23332 0.186476 5.17189 0.2524 5.12296C0.318324 5.07404 0.393241 5.03858 0.472871 5.01861C0.552501 4.99865 0.635285 4.99456 0.716493 5.0066C0.797701 5.01863 0.875743 5.04655 0.94616 5.08875L9.99991 10.5213L19.0537 5.08875C19.1241 5.04656 19.2021 5.01866 19.2833 5.00663C19.3645 4.99461 19.4473 4.99869 19.5269 5.01866C19.6066 5.03862 19.6815 5.07407 19.7474 5.12299C19.8133 5.17191 19.869 5.23333 19.9112 5.30375C19.9533 5.37417 19.9813 5.45221 19.9933 5.53342C20.0053 5.61462 20.0012 5.6974 19.9813 5.77703C19.9613 5.85666 19.9258 5.93157 19.8769 5.9975C19.828 6.06342 19.7666 6.11906 19.6962 6.16125L9.99991 11.9788L0.30366 6.1625C0.233228 6.12032 0.171794 6.06469 0.122869 5.99876C0.0739445 5.93284 0.0384865 5.85792 0.0185209 5.77829C-0.00144469 5.69866 -0.00552674 5.61588 0.00650794 5.53467C0.0185426 5.45346 0.0464582 5.37542 0.0886602 5.305V5.30375Z",
    fill: "#512DA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.44006 11.165L8.98006 10.85L8.35006 9.77L7.81006 10.085L8.44006 11.165ZM0.940059 15.54L8.44006 11.165L7.81006 10.085L0.310059 14.46L0.940059 15.54ZM11.5601 11.165L11.0201 10.85L11.6501 9.77L12.1901 10.085L11.5601 11.165ZM19.0601 15.54L11.5601 11.165L12.1901 10.085L19.6901 14.46L19.0601 15.54Z",
    fill: "#512DA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_1070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.71ff9858b0407af9f1e027dad3541b0b.svg";
export { ForwardRef as ReactComponent };